export default __webpack_public_path__ + "5049090.png";